/**
 * Utility functions for handling legal form formatting and normalization
 */

/**
 * Convert a string to sentence case (first letter uppercase, rest lowercase)
 */
export const toSentenceCase = (text: string): string => {
    if (!text || text.length === 0) return text;
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

/**
 * Normalize legal form for display - converts to sentence case
 */
export const formatLegalForm = (legalForm: string | undefined): string => {
    if (!legalForm) return 'Not specified';
    return toSentenceCase(legalForm);
};

/**
 * Normalize legal form for grouping in filters - converts to sentence case for consistent grouping
 * This helps merge variants like "LIMITED LIABILITY COMPANY", "Limited Liability Company", etc.
 */
export const normalizeLegalFormForFilter = (legalForm: string): string => {
    if (!legalForm) return '';
    return toSentenceCase(legalForm.trim());
};

/**
 * Format entity status for display - converts to sentence case
 */
export const formatEntityStatus = (entityStatus: string | undefined): string => {
    if (!entityStatus) return 'Not specified';
    return toSentenceCase(entityStatus);
};
